import React from "react";
import styles from "./Spinner.css";
import Loader from "react-loader";


var Spinner = ({loaded, className}) =>
    (
      <Loader loaded={loaded} lines={25} length={2.5} width={2.5} radius={40} corners={1} rotate={0} direction={1} speed={1.75} trail={80} shadow={false} hwaccel={true} className={className} zIndex={2e9} top="60%" left="50%" scale={.8}></Loader>
    )

export default Spinner



// WEBPACK FOOTER //
// ./src/html-components/SpinnerBig.jsx